import { axiosInstance } from 'config/axios/axios.config.ts';
import { paths } from '@types';
import { useQuery } from '@tanstack/react-query';
import { stableKey } from 'common/cache/util.ts';
import { NotificationsFilters } from 'components/Header/components/Notifications/hooks';

const notificationsRequest = async (props: NotificationsFilters) => {
  const response = axiosInstance.get<
    paths[`/notifications`]['get']['responses']['200']['content']['application/json']
  >(`/notifications`, {
    params: {
      limit: props.limit,
      page: props.page,
      ...(props.status && { status: props.status }),
    },
  });
  const data = (await response).data;

  return data;
};

export const useNotificationListQuery = ({
  props,
}: {
  props: NotificationsFilters;
}) => {
  const query = useQuery({
    queryKey: ['notifications', stableKey(props)],
    queryFn: () => notificationsRequest(props),
  });

  return query;
};
